import { CouponInfo, MerchantInfo } from '@tencent/wphk-components-wecoupon';

/**
 * 分页数据
 */
export interface PageResult<T> {
  /** 总记录数 */
  totalCount?: number,
  /** 是否有下一页数据 */
  hasNextPage?: boolean,
  /** 当前页数据列表项 */
  dataList: T[]
};

/**
 * 页面加载状态
 */
export enum ViewLoadState {
  /** 加载中 */
  Loading = 1,
  /** 加载失败 */
  Error = 2,
  /** 加载成功 */
  Success = 3
}

/**
 * 券分类
 */
export type CouponClass = {
  /**
   * 分类ID
   */
  classId: string;
  /**
   * 分类名称
   */
  className: string;
};

/** 广告位类型 */
export enum AdType {
  /** 抢券有So商户展示券广告位类型 */
  spAd = 0,
  /** 自定义广告 */
  otherAd,
  /** 分享裂变券 */
  shareCouponAd,
};

/** 抢券有 so 广告位配置 */
export type CouponAdConf = {
  /** 券列表位置类型 */
  type: PositionType.ad;
  /** 投放计划 id */
  dpId: number;
  /** 广告位类型 */
  adType: AdType;
  /** 广告位所属行业分类 */
  adClassId: string;
  /** 广告位排序 从 1 开始 */
  adOrder: number;
  /** 广告位banner图片链接 (AdType.spAd / AdType.othterAd) */
  adShowBannerUrl?: string;
  /** 是否展示广告角标(只有商户广告券/自定义广告券 才有，分享券肯定是false且没有使用) */
  isShowAdIcon: boolean;
  /** 广告位商户ID (AdType.spAd) */
  adSpId?: string;
  /** 广告位跳转地址 (AdType.othterAd) */
  adJumpUrl?: string;
  /** 小程序 appid (AdType.othterAd)*/
  appid?: string,
  /** 小程序 username (AdType.othterAd)*/
  username?: string,
  /** 小程序 path (AdType.othterAd)*/
  path?: string,
  /** 分享裂变券 id (AdType.shareCouponAd) */
  adCouponId?: string;
  /** 扩展信息, 分享券用到 */
  extra?: any;
};
/** 券列表位置类型 */
export enum PositionType {
  /** 抢券有 so 券 */
  coupon = 'coupon',
  /** 广告位 */
  ad = 'ad',
}

// 带有广告位标识的商户信息
export type MerchantInfoWithAd = MerchantInfo & { isFromAd?: boolean, dpId?: number };

// 广告位领券类型
export type ReceivedCouponListType = Array<{couponId: string, userScid: string}>;

// 获取带广告位的券列表
export type GetCouponListWithAdOpts = {
  /** 券列表 */
  list: any[],
  /** 广告位列表 */
  adList: CouponAdConf[],
  /** 分类 */
  classId: string,
  /** 分类下券是否加载完成 */
  isComplete: boolean
};

/** 广告券集合 */
export type AdSet = {
  type: PositionType.ad;
  adOrder: number;
  data: CouponAdConf[];
};

/** 展示券/优惠券 & 广告券 合并后的券列表 */
export type MergeCouponListItem = AdSet | CouponInfo;
